import Btn from '@/components/Button/Button.vue';
import { ImageView, ImageSize } from '@/components/ImageView';
import EditSvg from '@/assets/icons/edit.svg';
import { mdiClose } from '@mdi/js';
import { computed, defineComponent, onMounted, ref, } from '@vue/composition-api';
import { useAuthUser } from '@/composables';
import LoadingSpinner from '@/components/Loaders/LoadingSpinner.vue';
import { getSingleObject } from '@/api/v2/requests/objects';
import { ClientRouteName } from '@/router/router.constants';
export default defineComponent({
    components: {
        LoadingSpinner,
        Btn,
        ImageView,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        hidePreviewButton: Boolean,
        offerId: {
            type: String,
            default: undefined,
        },
    },
    setup(props) {
        const { isAdmin } = useAuthUser();
        const object = ref(null);
        const isLoading = ref(true);
        onMounted(async () => {
            object.value = await getSingleObject(props.id);
            isLoading.value = false;
        });
        const showButtonLink = computed(() => {
            if (props.offerId) {
                return {
                    name: ClientRouteName.OBJECT_IN_OFFER_DETAILS,
                    params: { objectId: props.id, offerId: props.offerId },
                };
            }
            return {
                name: 'ObjectDetails',
                params: {
                    objectId: props.id,
                    objectTypeId: object.value?.objectType?.id,
                },
            };
        });
        return {
            EditSvg,
            mdiClose,
            ImageSize,
            isAdmin,
            object,
            isLoading,
            showButtonLink,
        };
    },
});
